import React from 'react';

/**
 * Renders a single row of icon + content (pills, text, etc).
 * Props:
 *  - Icon: a Lucide-react icon component
 *  - children: the content next to the icon
 */
const InfoRow = ({ Icon, children }) => (
  <div className="info-section">
    <Icon size={20} className="icon-inline" />
    {children}
  </div>
);

export default InfoRow;
